import { render, staticRenderFns } from "./orderPersonLimit.vue?vue&type=template&id=a161d43e&scoped=true"
import script from "./orderPersonLimit.vue?vue&type=script&lang=js"
export * from "./orderPersonLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161d43e",
  null
  
)

export default component.exports